import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  pt: {
    roles: {
      OWNER: 'Gerente',
      OPERATOR: 'Operador',
      FACILITIES: 'Facilities',
      ON_DUTY: 'Plantonista',
    },
    variables: {
      TEMPERATURE: 'Temperatura',
      HUMIDITY: 'Umidade',
      END_OF_COURSE: 'Porta aberta',
    },
    filters: {
      ALL: 'Geral',
      ENVIRONMENT: 'Ambiente',
      REFRIGERATOR: 'Geladeira',
    },
    alertNature: {
      AIR_CURTAIN_DISABLED: 'Cortina de ar fora de funcionamento',
      DEHUMIDIFIER_DISABLED: 'Desumidificador fora de funcionamento',
      ENERGY_DISABLED: 'Falta de energia elétrica',
      ENVIRONMENT_OPEN: 'Forro de ambiente aberto',
      COOLER_DISABLED: 'Máquina de refrigeração fora de funcionamento',
      REFRIGERATOR_DOOR_OPEN: 'Porta da geladeira aberta acima do tempo permitido',
      ENVIRONMENT_DOOR_OPEN: 'Porta do ambiente aberta',
      OPEN_DOOR: 'Porta aberta',
      NA: 'N/A',
    },
    errors: {
      'email-exists': 'E-mail já existe',
      'phone-exists': 'Telefone já existe',
      'control-exists': 'Controle já existe',
      'environment-name-exists': 'Ambiente já existe',
      'actuator-exists': 'Atuador já existe',
      'actuator-id-exists': 'Id do atuador já existe',
      'dehumidifier-exists': 'Desumidificador já existe',
      'empty-weekdays': 'Selecione pelo menos um dia da semana',
      'invalid-password': 'Senha atual não confere',
      'duplicated-dehumidifier-id': 'Id do desumidificador já existe',
      'duplicated-ac-id': 'Id do ar atuador já existe',
      'duplicated-sensor-name': 'Sensor já existe',
      'invalid-minTemperatureOffset':
        'O valor mínimo do offset de temperatura inserido não é permitido',
      'invalid-maxTemperatureOffset':
        'O valor máximo do offset de temperatura inserido não é permitido',
      'invalid-minHumidityOffset': 'O valor mínimo do offset de umidade inserido não é permitido',
      'invalid-maxHumidityOffset': 'O valor máximo do offset de umidade inserido não é permitido',
      'duplicated-priority': 'Prioridade já existe',
      'duplicated-user': 'Usuário já foi escalado neste ambiente',
      'invalid-priority': 'Prioridade inválida',
      'invalid-priority-sequence': 'As prioridades devem ser sequenciais',
      'filters-required': 'Você precisa filtrar por ambiente e período de tempo',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'pt', // default language
  ns: ['roles', 'variables', 'filters', 'alertNature', 'errors'],
  defaultNS: 'variables',
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
